import { apiSlice } from './apiSlice';
import type {
  ListUserMessagesParams,
  UnreadMessageCountResponse,
  UserMessagesResponse,
} from '@/types/userMessage';

export const userMessagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserMessages: builder.query<UserMessagesResponse, ListUserMessagesParams | void>({
      query: (params) => ({
        url: '/user-messages',
        method: 'GET',
        params: params ?? undefined,
        requiresAuth: true,
      }),
      providesTags: ['UserMessages'],
    }),

    getUnreadMessageCount: builder.query<UnreadMessageCountResponse, void>({
      query: () => ({
        url: '/user-messages/unread-count',
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: ['UnreadMessageCount'],
    }),

    markMessageRead: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/user-messages/${id}/read`,
        method: 'PATCH',
        requiresAuth: true,
      }),
      invalidatesTags: ['UserMessages', 'UnreadMessageCount'],
    }),

    markAllMessagesRead: builder.mutation<{ success: boolean }, void>({
      query: () => ({
        url: '/user-messages/read-all',
        method: 'PATCH',
        requiresAuth: true,
      }),
      invalidatesTags: ['UserMessages', 'UnreadMessageCount'],
    }),

    deleteMessage: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/user-messages/${id}`,
        method: 'DELETE',
        requiresAuth: true,
      }),
      invalidatesTags: ['UserMessages', 'UnreadMessageCount'],
    }),

    clearAllMessages: builder.mutation<{ success: boolean }, void>({
      query: () => ({
        url: '/user-messages/all',
        method: 'DELETE',
        requiresAuth: true,
      }),
      invalidatesTags: ['UserMessages', 'UnreadMessageCount'],
    }),
  }),
});

export const {
  useGetUserMessagesQuery,
  useGetUnreadMessageCountQuery,
  useMarkMessageReadMutation,
  useMarkAllMessagesReadMutation,
  useDeleteMessageMutation,
  useClearAllMessagesMutation,
} = userMessagesApi;
